import { Badge } from "react-bootstrap";

type Props = {
  name: string;
  className?: string;
};

const RoleBadge = ({ name, className }: Props) => {
  return (
    <Badge className={className} bg="info">
      {name}
    </Badge>
  );
};

export default RoleBadge;
